var _dec, _dec2, _dec3, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { attr } from '@ember-data/model';
import CatalogFragment from '@square/dashboard-items-data/models/connect/catalog-fragment';
import { CatalogItem as CatalogItemProto } from '@square/dashboard-protos/models/squareup/connect/v2/catalog/resources/datatypes';
const IngredientTypeProto = CatalogItemProto.FoodAndBeverageDetails.DietaryPreferenceType;
const StandardIngredientProto = CatalogItemProto.FoodAndBeverageDetails.Ingredient.StandardIngredient;

// The protos have numeric values for each key but we want the string
// values for saving.

const ingredientTypeObject = {};
Object.keys(IngredientTypeProto).forEach(key => {
  const _key = key;
  ingredientTypeObject[_key] = _key;
});
export const INGREDIENT_TYPE = Object.freeze(ingredientTypeObject);
const standardIngredientObject = {};
Object.keys(StandardIngredientProto).forEach(key => {
  const _key = key;
  standardIngredientObject[_key] = _key;
});
export const STANDARD_INGREDIENT = Object.freeze(standardIngredientObject);
let Ingredient = (_dec = attr('string'), _dec2 = attr('string'), _dec3 = attr('string'), _class = class Ingredient extends CatalogFragment {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "type", _descriptor, this);
    _initializerDefineProperty(this, "standardName", _descriptor2, this);
    _initializerDefineProperty(this, "customName", _descriptor3, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "type", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "standardName", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "customName", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { Ingredient as default };